// import { achieveFontUrlByFontName } from '@/hooks/load-font.ts'

export const addFontFile = (editor, fontName) => {
  const escapedFontName = CSS.escape(fontName)
  if (document.querySelector(`style.${escapedFontName}`)) return
  const fontUrl = achieveFontUrlByFontName(fontName)
  if (fontUrl) {
    // 使用DOM方式添加字体样式
    const style = document.createElement('style')
    style.className = escapedFontName
    style.textContent = `
      @font-face {
        font-family: '${fontName.replace(/'/g, "\\'")}';
        src: url('${fontUrl}');
      }
    `
    document.head.appendChild(style)
    // eslint-disable-next-line no-param-reassign
    // editor.dom.doc.head.lastChild.innerHTML += `@font-face {
    //   font-family: '${fontName}';
    //   src: url('${fontUrl}');
    // }`
  }
}
